// ForgotPasswordSuccess.tsx
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../store/useAuthStore3";

export const ForgotPasswordSuccess: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Box sx={{ textAlign: 'center', p: 3, border: '1px solid #ccc', borderRadius: '8px', maxWidth: 400, mx: 'auto' }}>
      <Typography variant="h5" mb={2} color="success.main">
        {t('ForgotPassword.SuccessTitle', 'Письмо отправлено!')}
      </Typography>
      <Typography mb={3} color="text.secondary">
        {t('ForgotPassword.SuccessText', 'Мы отправили инструкции по сбросу пароля на вашу почту. Пожалуйста, проверьте входящие письма и папку "Спам".')}
      </Typography>
      <Button 
        variant="outlined" 
        onClick={() => useAuthStore.setState({ authState: 'LOGIN' })}
      >
        {t('ForgotPassword.BackToLogin', 'Назад к входу')}
      </Button>
    </Box>
  );
};